module.exports = __webpack_public_path__ + "img/archive.2361206f.svg";